[
  {
    "key": "domestic",
    "data": [
      {
        "party": "Republican",
        "control": 18.56,
        "treatment": 17.1
      },
      {
        "party": "Democrat",
        "control": 11.5,
        "treatment": 12.83
      }
    ]
  },
  {
    "key": "international",
    "data": [
      {
        "party": "Republican",
        "control": 16.51,
        "treatment": 18.24
      },
      {
        "party": "Democrat",
        "control": 12.26,
        "treatment": 14.48
      }
    ]
  }
]